import { render, staticRenderFns } from "./AchContributions.vue?vue&type=template&id=5a427d91&scoped=true"
import script from "./AchContributions.vue?vue&type=script&lang=ts"
export * from "./AchContributions.vue?vue&type=script&lang=ts"
import style0 from "./AchContributions.vue?vue&type=style&index=0&id=5a427d91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a427d91",
  null
  
)

export default component.exports